/**
 * Builds the query parameters for the offset based pagination.
 * @param offset Offset
 * @param range Range
 * @param range SearchTerm, an optional term used for filtering the results.
 * @description This function helps to generate the query parameters for the pagination.
 * @returns An object with query params.
 */
export const buildPaginationQuery = (offset: number, range: number, searchTerm?: string) => {
	const params: { Offset: string; Range: string; SearchTerm?: string } = {
		Offset: offset.toString(),
		Range: range.toString(),
	};

	if (searchTerm) {
		params.SearchTerm = searchTerm;
	}

	return params;
};
